import { DragEndEvent } from '@dnd-kit/core'
import { useCallback } from 'react'
import { reorderRowsById } from '../DataTable.helpers'
import { DataTableReorder } from '../DataTable.types'

type UseDataTableReorderArgs<TRow> = {
    reorder?: DataTableReorder<TRow>
    rows: TRow[]
    getRowId: (row: TRow) => string
    isInStoredOrder: boolean
    rowCountOnPage: number
    hasExpandedRow: boolean
}

export const useDataTableReorder = <TRow>({
    reorder,
    rows,
    getRowId,
    isInStoredOrder,
    rowCountOnPage,
    hasExpandedRow,
}: UseDataTableReorderArgs<TRow>) => {
    const isReorderEnabled =
        !!reorder && !reorder.isDisabled && isInStoredOrder && rowCountOnPage > 1 && !hasExpandedRow

    const onReorder = reorder?.onReorder

    const handleDragEnd = useCallback(
        ({ active, over }: DragEndEvent) => {
            if (!over || !onReorder) return

            const reorderedRows = reorderRowsById(rows, getRowId, String(active.id), String(over.id))

            if (reorderedRows) onReorder(reorderedRows)
        },
        [rows, getRowId, onReorder]
    )

    return { isReorderEnabled, handleDragEnd }
}
